import React, { useContext } from 'react';
import Context from './SessionProvider';
import { IdleTimerProvider } from 'react-idle-timer';
import APP from '../../tools/AppRoutes';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

const Afk = ({ history }) => {
    
    const { logout, user } = useContext(Context);

    const onPrompt = () => {

        if(history.location.pathname !== '/'){
            if(user === "" || user === null || user === undefined)
                history.push(APP.INDEX);
        }
    }

    const onIdle = () => {
        logout();
        history.push(APP.INDEX);        
    }
        
    return (            
        <IdleTimerProvider
            element={document}
            onIdle={onIdle}
            onPrompt={onPrompt}
            debounce={250}
            timeout={1000 * 60 * 15} //milisegundos * segundos x minuto
        />
    )    
}

export default withRouter(Afk);